import { render, staticRenderFns } from "./PayBarCode.vue?vue&type=template&id=6a5b3afe"
import script from "./PayBarCode.vue?vue&type=script&lang=js"
export * from "./PayBarCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\certbuyliantuo\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a5b3afe')) {
      api.createRecord('6a5b3afe', component.options)
    } else {
      api.reload('6a5b3afe', component.options)
    }
    module.hot.accept("./PayBarCode.vue?vue&type=template&id=6a5b3afe", function () {
      api.rerender('6a5b3afe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/home/PayBarCode.vue"
export default component.exports